import { Box,Typography } from "@mui/material";
import {
  IDNumberComponent,
  TaxNumberComponent,
} from "@soqs/common";
import { useSelector } from "react-redux";
import {
  dropdownOptions,
  requesterDetailsFormState,
} from "../../../features/CaptureDetailsSlice";
import SelectComponent from "../../FormComponents/DefaultSelect/SelectComponent";
import MenuItemsForDropdown from "../../FormComponents/MenuItemsForDropdown/MenuItemsForDropdown";
import DateSelectorComponent from "../../FormComponents/DateSelector/DateSelectorComponent";
import InputFieldComponent from "../../FormComponents/InputField/InputField";
import { southAfricanPassportCountry } from "../FormValidationHelper";

export interface IDSelectionProps {
  prefix: string;
}

const IDSelectionComponent = (props: IDSelectionProps) => {
  const captureDetailsForm = useSelector(requesterDetailsFormState);
  const selectOptions = useSelector(dropdownOptions);

  const getMaxDate = (): Date => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate()+1);
    return maxDate;
  }

  return (
    <>
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={(theme) => ({
          flex: "0 0 49%",
          [theme.breakpoints.down("sm")]: {
            flex: "0 0 100%",
          },
        })}
      >
        <SelectComponent
          id={`${props.prefix}-id-type`}
          label="ID Type"
          name={`${props.prefix}_idType`}
          options={MenuItemsForDropdown("idTypes", selectOptions)}
          required={true}
        />
      </Box>

      {captureDetailsForm?.values[`${props.prefix}_idType`] === "id_number" ? (
        <Box
          sx={(theme) => ({
            flex: "0 0 49%",
            [theme.breakpoints.down("sm")]: {
              flex: "0 0 100%",
            },
          })}
        >
          <IDNumberComponent
            id={`${props.prefix}-id-number`}
            label="ID Number"
            name={`${props.prefix}_idNumber`}
            required={true}
            parse={(value: any) => value ? value?.trim() : ""}
          />
        </Box>
      ) : null}

      {captureDetailsForm?.values[`${props.prefix}_idType`] ===
      "asylum_seeker" ? (
        <>
          <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
            flex: "0 0 100%",
          }})}>
            <InputFieldComponent id={`${props.prefix}-asylum-number`} label="Asylum Number" name={`${props.prefix}_asylumNo`} required={true} maxLength={20} minLength={8}/>
          </Box>

          <Box
            sx={(theme) => ({
              flex: "0 0 49%",
              [theme.breakpoints.down("sm")]: {
                flex: "0 0 100%",
              },
            })}
          >
            <TaxNumberComponent
              id={`${props.prefix}-tax-reference-number`}
              label="Tax Reference Number"
              name={`${props.prefix}_TRN`}
              required={true}
              parse={(value: any) => value ? value?.trim() : ""}
            />
          </Box>
        </>
      ) : null}

      {captureDetailsForm?.values[`${props.prefix}_idType`] ===
      "passport_number" ? (
        <>
          <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
            flex: "0 0 100%",
          }})}>
            <InputFieldComponent
              id={`${props.prefix}-passport-number`}
              label="Passport Number"
              name={`${props.prefix}_passportNo`}
              required={true}
              minLength={6}
              maxLength={15}
            />
          </Box>

          <Box
            sx={(theme) => ({
              flex: "0 0 49%",
              [theme.breakpoints.down("sm")]: {
                flex: "0 0 100%",
              },
            })}
          >
            <DateSelectorComponent
              id={`${props.prefix}-passport-date-of-issue`}
              label="Passport Date of Issue"
              name={`${props.prefix}_passportDate`}
              required={true}
              maxDate={getMaxDate()}
              disableFuture={true}
            />
          </Box>

          <Box
            sx={(theme) => ({
              flex: "0 0 49%",
              [theme.breakpoints.down("sm")]: {
                flex: "0 0 100%",
              },
            })}
          >
            <SelectComponent
              id={`${props.prefix}-passport-country-of-issue`}
              label="Passport Country of Issue"
              name={`${props.prefix}_passportCountry`}
              options={MenuItemsForDropdown("country", selectOptions)}
              required={true}
            />
          </Box>
        </>
      ) : null}
    </Box>

    {southAfricanPassportCountry(captureDetailsForm) ? (
      <Typography
        sx={(theme) => ({
          color: theme.palette.error.main,
          fontSize: "0.75rem",
          ml: "2px",
          mt: "12px",
          mb: "12px"
        })}
      >
        South African issued passport not allowed. Capture South African ID number.
      </Typography>
      ) : null}
    </>
  );
};

export default IDSelectionComponent;
